module.exports = __webpack_public_path__ + "static/media/hero-right.79f370fe.jpg";